module.exports = __webpack_public_path__ + "media/img/city_bcg@2x-893539b9.png";